import {Component} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule} from '@angular/common';

export class RegistrationLeadTracking {
  constructor(
    // caution: modifying the field names directly causes changes in the database and can impact the analysis of the data!
    public startupId: string,
    public checkbox: string[],
    public other: string,
    public otherStartup: string,
    public retailPartners: string[],
  ) {}
}

export class TrackingFormNames {
  // caution: modifying the field names directly causes changes in the database and can impact the analysis of the data!
  public readonly OTHERSTARTUP = 'OTHERSTARTUP';
  public readonly RETAILPARTNER = 'RETAILPARTNER';
  public readonly BARTELSLANGNESS = 'BARTELSLANGNESS';
  public readonly DM = 'DM';
  public readonly GLOBUS = 'GLOBUS';
  public readonly MUELLER = 'MUELLER';
  public readonly ROSSMANN = 'ROSSMANN';
  public readonly KAES = 'KAES';
  public readonly KAUFLAND = 'KAUFLAND';
  public readonly INSTAGRAM = 'INSTAGRAM';
  public readonly LINKEDIN = 'LINKEDIN';
  public readonly MARKANT = 'MARKANT';
  public readonly OTHERS = 'OTHERS';
  public readonly SEARCHENGINE = 'SEARCHENGINE';
}

@Component({
  selector: 'app-signup-track-lead',
  templateUrl: './signup-track-lead.component.html',
  styleUrls: ['./signup-track-lead.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule],
})
export class SignupTrackLeadComponent {
  trackingData: RegistrationLeadTracking = new RegistrationLeadTracking('', [], '', '', []);
  trackingDataSubject: BehaviorSubject<RegistrationLeadTracking> = new BehaviorSubject(this.trackingData);
  formNames = new TrackingFormNames();
  retailPartnersVisible = false;
  otherStartupTextVisible = false;
  othersTextVisible = false;

  public currentValue(): Observable<RegistrationLeadTracking> {
    return this.trackingDataSubject.asObservable();
  }

  checkboxSimpleChanged(event: CustomEvent, nameCheckbox: string) {
    this.modifyCheckboxTracking(
      event,
      nameCheckbox,
      () => null,
      () => null,
    );
  }

  checkboxOtherStartupChanged(event: CustomEvent, nameCheckbox: string) {
    const actionOnChecked = () => (this.otherStartupTextVisible = true);
    const actionOnUnchecked = () => {
      this.setOtherStartupOnTracking('');
      this.otherStartupTextVisible = false;
    };
    this.modifyCheckboxTracking(event, nameCheckbox, actionOnChecked, actionOnUnchecked);
  }

  checkboxOthersChanged(event: CustomEvent, nameCheckbox: string) {
    const actionOnChecked = () => (this.othersTextVisible = true);
    const actionOnUnchecked = () => {
      this.setOthersOnTracking('');
      this.othersTextVisible = false;
    };
    this.modifyCheckboxTracking(event, nameCheckbox, actionOnChecked, actionOnUnchecked);
  }

  checkboxRetailPartnerChanged(event: CustomEvent, nameCheckbox: string) {
    const actionOnChecked = () => (this.retailPartnersVisible = true);
    const actionOnUnchecked = () => {
      this.trackingData.retailPartners = [];
      this.retailPartnersVisible = false;
    };
    this.modifyCheckboxTracking(event, nameCheckbox, actionOnChecked, actionOnUnchecked);
  }

  private modifyCheckboxTracking(event: CustomEvent, nameCheckbox: string, actionOnChecked: () => void, actionOnUnchecked: () => void) {
    if (event.detail) {
      this.trackingData.checkbox.push(nameCheckbox);
      actionOnChecked();
    } else {
      this.trackingData.checkbox.splice(this.trackingData.checkbox.indexOf(nameCheckbox), 1);
      actionOnUnchecked();
    }
    this.trackingDataSubject.next(this.trackingData);
  }

  retailPartnerDetailChanged(event: CustomEvent, name: string) {
    if (event.detail) {
      this.addRetailPartnerToTracking(name);
    } else {
      this.removeRetailPartnerFromTracking(name);
    }
    this.trackingDataSubject.next(this.trackingData);
  }

  textOtherStartupChanged(event: CustomEvent) {
    this.setOtherStartupOnTracking(event.detail);
  }

  textOthersChanged(event: CustomEvent) {
    this.setOthersOnTracking(event.detail);
  }

  private addRetailPartnerToTracking(name: string) {
    this.trackingData.retailPartners.push(name);
  }

  private removeRetailPartnerFromTracking(name: string) {
    this.trackingData.retailPartners.splice(this.trackingData.retailPartners.indexOf(name), 1);
  }

  private setOtherStartupOnTracking(otherStartup: string) {
    this.trackingData.otherStartup = otherStartup;
    this.trackingDataSubject.next(this.trackingData);
  }

  private setOthersOnTracking(others: string) {
    this.trackingData.other = others;
    this.trackingDataSubject.next(this.trackingData);
  }
}
